import { render, staticRenderFns } from "./QueuesEmpty.vue?vue&type=template&id=97e0e23a"
import script from "./QueuesEmpty.vue?vue&type=script&lang=js"
export * from "./QueuesEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports